"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignedExprNode = void 0;
const sheet_db_1 = require("../../../sheet_db");
const base_1 = require("../base");
class SignedExprNode extends base_1.InternalNode {
    constructor(originalNode, astParent) {
        super(originalNode, astParent);
        this._startPosition = originalNode.start.start;
        this._endPosition = originalNode.stop?.stop ?? originalNode.start.stop;
        this._treeNodeType = base_1.TreeNodeType.SIGNED_NODE;
    }
    accept(v) {
        if (v.visitSignedExpr)
            v.visitSignedExpr(this);
        this.visitChildren(v);
    }
    getReturnType() {
        // TODO: improve return type recognition checking children types
        return sheet_db_1.ColumnType.NUMBER;
    }
}
exports.SignedExprNode = SignedExprNode;
